<template>
  <div class="container-fluid">
      <div class="page-header min-height-100"></div>

      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
              </div>
            </div>

            <div class="col-auto my-auto">
                <div>
          <h5 class="mb-0">{{ data.username || "Novo Usuário" }}</h5>
          <small class="text-muted">Cadastre um novo usuário para acessar o sistema</small>
        </div>
            </div>

            <div class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0">
              <div class="nav-wrapper position-relative end-0">
                <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <button
                      class="mb-0 btn bg-gradient-success btn-sm me-2"
                      type="button"
                      @click="salvarUnico(data)"
                    >
                      Salvar
                    </button>
                  </li>

                  <li class="nav-item">
                    <button
                      class="mb-0 btn btn-outline-danger btn-sm"
                      type="button"
                      @click="fecharUnico()"
                    >
                      Cancelar
                    </button>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
  </div>

  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="mt-4 col-lg-8 mt-lg-0">
        <div class="card">
          <div class="card-body">

            <!-- Email e Nível -->
            <div class="row">
              <div class="col-12 col-sm-6">
                <label>Email</label>
                <input class="form-control" type="text" v-model="data.username" />
              </div>

              <div class="col-12 col-sm-6">
                <label>Nível</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  v-model="data.role"
                >
                    <option v-for="m in niveis" :key="m" :value="m">{{ m }}</option>
                </select>
              </div>
            </div>

            <!-- Senha -->
            <div class="row">
              <div class="col-sm-5">
                <label class="mt-4">Senha 
                  <i @click="data.show_p1 = true" class="fas fa-eye text-dark opacity-10"></i>
                </label>
                <input class="form-control" :type="data.show_p1 ? 'text' : 'password'" v-model="data.password" />
              </div>

              <div class="col-sm-5">
                <label class="mt-4">Confirme a Senha 
                  <i @click="data.show_p2 = true" class="fas fa-eye text-dark opacity-10"></i>
                </label>
                <input class="form-control" :type="data.show_p2 ? 'text' : 'password'" v-model="data.password_confirm" />
              </div>

              <div v-if="data.password != data.password_confirm" class="col-12 text-danger">
                  Senhas não são iguais
              </div>
            </div>

            <!-- Operação -->
            <div class="row mt-3">
              <div class="col-sm-6">
                <label>Operação</label>
                <select class="form-control" v-model="data.operacao_id">
                  <option v-for="item in operacoes" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="col-sm-4">
                <label>Operador Logístico</label>
                <select class="form-control" v-model="data.operador_id">
                    <option disabled value="">Selecione um Operador</option>
                    <option value="nenhum">Nenhum Operador</option>
                    <option v-for="m in operadores" :key="m.id" :value="m.id">
                      {{ m.nome_completo }}
                    </option>
                </select>
              </div>
               <div class="col-sm-2 mt-2">
                  <label></label><br>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      @click="goOperadores()"
                    >
                      Novo
                    </button>
               </div>


            </div>

            <!-- Permissões -->
            <div class="row mt-4" v-if="data.role!='master' && data.role!='motorista'  ">
              <div class="col-12">
                <label class="mb-2">Permissões</label>
                  <div class="row">
                <div
                  v-for="p in permissoesLista"
                  :key="p.key"
                  class="col-3 form-check"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="data.permissoes[p.key]"
                  />
                  <label class="form-check-label">{{ p.label }}</label>
                </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>

import { useRouter } from 'vue-router';

export default {
  name: "FormularioUsuarios",

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    niveis: {
      type: Array,
      default: () => []
    },
    operacoes: {
      type: Array,
      default: () => []
    },
    operadores: {
      type: Array,
      default: () => []
    },
    
    salvarUnico: {
      type: Function,
      required: true
    },
    fecharUnico: {
      type: Function,
      required: true
    }
  },

  setup(props) {
    
    const router = useRouter();

    const permissoesLista = [
      { key: "dashboard", label: "Dashboard" },
      { key: "pedidos", label: "Pedidos" },
      { key: "rotas", label: "Rotas" },
      { key: "romaneio", label: "Romaneio" },
      { key: "monitoramento", label: "Monitoramento" },
      { key: "operacoes", label: "Operações" },
      { key: "veiculos", label: "Veículos" },
      { key: "operadores", label: "Operadores" },
      { key: "unidades_transporte", label: "Unidades de Transporte" },
      { key: "usuarios", label: "Usuários" },
      { key: "configuracoes", label: "Configurações" }
    ];
    




      const inicializarPermissoes = () => {
        const base = {};
        permissoesLista.forEach(p => {
          base[p.key] = false;
        });
        return base;
      };

      if (!props.data.permissoes) {
        props.data.permissoes = inicializarPermissoes();
      }

      if (typeof props.data.permissoes === "string") {
        try {
          props.data.permissoes = JSON.parse(props.data.permissoes);
        } catch {
          props.data.permissoes = inicializarPermissoes();
        }
      }

      if (typeof props.data.permissoes === "string") {
           props.data.permissoes = JSON.parse(props.data.permissoes);
      }
      //console.log(props.data.permissoes)

      if (Object.keys(props.data.permissoes).length === 0) {
        props.data.permissoes = inicializarPermissoes();
      }






    const salvarUnico = (usuario) => { 
      props.salvarUnico(usuario);
    };

    const fecharUnico = () => props.fecharUnico();

    const goOperadores = () => {
        router.push('/motoristas/criar');
    }

    return {
      salvarUnico,
      fecharUnico,
      goOperadores,
      permissoesLista
    };
  }
};
</script>
